import PathDataTableMappingDto from "../../../dtos/pathdatatablemodule/PathDataTableMappingDto";
import ScheduleDto from "../../../dtos/schedulermodule/ScheduleDto";
import DataTableReadDto from "../../../dtos/pathcommonmodule/DataTableReadDto";
import DataTableRelationDto from "../../../dtos/pathcommonmodule/DataTableRelationDto";

class GetPathDataTableDetailResult {
    Id: number;
    Name: string;
    Source: DataTableReadDto | null;
    LinkedDataTables: DataTableRelationDto[];
    Mappings: PathDataTableMappingDto[];
    Schedule: ScheduleDto;
    AdvancedFilterMode: boolean;
    LastVersionId: number | null;
    PublishedVersionId: number | null;

    constructor(id: number, name: string, source: DataTableReadDto | null, linkedDataTables: DataTableRelationDto[], mappings: PathDataTableMappingDto[], schedule: ScheduleDto, lastVersionId: number | null, publishedVersionId: number | null, advancedFilterMode: boolean) {
        this.Id = id;
        this.Name = name;
        this.Source = source;
        this.LinkedDataTables = linkedDataTables;
        this.Mappings = mappings;
        this.Schedule = schedule;
        this.LastVersionId = lastVersionId;
        this.PublishedVersionId = publishedVersionId;
        this.AdvancedFilterMode = advancedFilterMode;
    }
}

export default GetPathDataTableDetailResult;
